export const OVERVIEW_FIELD_ISSUE_MARK_POSITION = { right: 52, top: 8 };
